var _path, _rect, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgGifi = function SvgGifi(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: props.color || 'currentColor',
    d: "M10.546 12.837v-.716H7.874v.967h1.38v.1a1.37 1.37 0 0 1-1.498 1.319c-1.055 0-1.723-.839-1.723-2.215 0-1.349.628-2.145 1.674-2.145a1.43 1.43 0 0 1 1.45 1.059h1.332A2.627 2.627 0 0 0 7.7 9.049c-1.863 0-3.023 1.23-3.023 3.261 0 2.061 1.16 3.3 3.054 3.3a2.568 2.568 0 0 0 2.815-2.773m2.922 2.663V9.159h-1.327V15.5zm3.1 0V13h2.58v-1.05H16.57v-1.7h2.83V9.159h-4.158V15.5z",
    "data-name": "Path 4862"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || 'currentColor',
    strokeMiterlimit: 10,
    strokeWidth: 1.4,
    transform: "translate(0 2)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 20,
    stroke: "none",
    rx: 5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 22.6,
    height: 18.6,
    x: 0.7,
    y: 0.7,
    rx: 4.3
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgGifi);
export default ForwardRef;